import { render, staticRenderFns } from "./FTVRequest.vue?vue&type=template&id=561263f5&"
import script from "./FTVRequest.vue?vue&type=script&lang=js&"
export * from "./FTVRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports